import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment, a as Host } from './index.js';
import { s as slotFilled } from './p-rUtJRH95.js';
import { p as parseHrefProp } from './p-DlCOw5Kl.js';
import { d as defineCustomElement$j } from './p-BbTg3Car.js';
import { d as defineCustomElement$i } from './p-7jxIfyyn.js';
import { d as defineCustomElement$h } from './p-CE-SFMeF.js';
import { d as defineCustomElement$g } from './p-BLpMhFGJ.js';
import { d as defineCustomElement$f } from './p-bjt-RAeH.js';
import { d as defineCustomElement$e } from './p-BZccBFnt.js';
import { d as defineCustomElement$d } from './p-Da2lAZSv.js';
import { d as defineCustomElement$c } from './p-DUcqAgyP.js';
import { d as defineCustomElement$b } from './p-Cx1d0m6y.js';
import { d as defineCustomElement$a } from './p-C8rNIEim.js';
import { d as defineCustomElement$9 } from './p-BU1hvS3W.js';
import { d as defineCustomElement$8 } from './p-CEvUoLql.js';
import { d as defineCustomElement$7 } from './p-CT2oAZeh.js';
import { d as defineCustomElement$6 } from './p-CCmod1sd.js';
import { d as defineCustomElement$5 } from './p-FpOQMZxV.js';
import { d as defineCustomElement$4 } from './p-CtbK9Pbz.js';
import { d as defineCustomElement$3 } from './p-cR96ip-k.js';
import { d as defineCustomElement$2 } from './p-Bn01tsA6.js';

const topNavCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host nav{align-content:center;align-items:center;background-color:var(--jw-theme-surface-elevated-default-bg-color);display:flex;flex:1 0 0;flex-wrap:wrap;gap:.75rem;justify-content:space-between;padding:.75rem 1.5rem}.user-menu-container{align-content:center;align-items:center;display:flex;gap:.125rem}.center-slot-container{flex-grow:1;max-width:var(--jw-container-md);min-width:var(--jw-container-xs);width:80%}.right-slot-container{align-items:center;display:flex;gap:.75rem;justify-content:center}";

const WuiTopNav$1 = /*@__PURE__*/ proxyCustomElement(class WuiTopNav extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.menuOpenChanged = createEvent(this, "menuOpenChanged", 7);
        /**
         * Controls if user menu is open
         */
        this.menuOpen = false;
    }
    toggleOpen(open = !this.menuOpen) {
        if (open === this.menuOpen) {
            return;
        }
        this.menuOpen = open;
        this.menuOpenChanged.emit(this.menuOpen);
    }
    getRightSideSlots() {
        return Array.from(this.elm.querySelectorAll('[slot="right-side-content"]')).map((elem) => (h("span", { innerHTML: elem.outerHTML })));
    }
    getStatusIndicator() {
        if (!this.statusIndicator) {
            return null;
        }
        return h("wui-tag", { ...this.statusIndicator });
    }
    getUserMenu() {
        if (!this.userMenu) {
            return null;
        }
        const { signoutButton, status, sections, ...rest } = this.userMenu;
        return (h("div", { class: "user-menu-container" }, status && h("wui-status", { ...status, intent: "warning", type: "icon" }), h("wui-more-menu", { ...rest, buttonType: "ghost", icon: this.menuOpen ? 'chevron-up' : 'chevron-down', iconPosition: "trailing", disabled: sections.length === 0, closeOnClickInside: true, menuPane: {
                placement: 'bottom-end',
                stretch: 'off',
            } }, h("wui-list", { class: "user-menu" }, sections.map((section) => {
            const { title, links } = section;
            return (h(Fragment, null, title && h("wui-list-item-header", { key: `section-title-${title}-${links.length}`, label: title }), links.map((link) => {
                return h("wui-list-item", { ...link, key: `user-menu-${link.label}`, as: ['a', parseHrefProp(link)] });
            }), h("wui-list-item-divider", null)));
        }), signoutButton && h("wui-list-item", { ...signoutButton, label: signoutButton.label || 'Sign out' })))));
    }
    renderRightSideContent() {
        const slots = this.getRightSideSlots();
        const userMenu = this.getUserMenu();
        const statusIndicator = this.getStatusIndicator();
        const rightContentElements = [statusIndicator, ...slots, userMenu].filter(Boolean);
        return (h("section", { class: "right-slot-container" }, rightContentElements.map((element, idx) => {
            return (h(Fragment, null, element, idx !== rightContentElements.length - 1 && h("wui-divider", { type: "vertical" })));
        })));
    }
    render() {
        return (h(Host, { key: '53baaf8ae3ea7fa5a8efcaffd49b78469f730036' }, h("nav", { key: '8a0100dd43b0ae292717973334ca67ad0a8daf25' }, h("section", { key: 'bec85138c75d36c8f68e9d1af2259f4779675a73', class: "left-slot-container" }, h("slot", { key: '0034501b67c226af95b7a74302d5fe1de3d684f1', name: "left-side-content" })), slotFilled(this.elm, 'center-content') && (h("section", { key: '7b6cbee09d78c4d4021e1ba5e705a95642bbd169', class: "center-slot-container" }, h("slot", { key: 'e7a169de387954b7f25861911606617f3da25f0e', name: "center-content" }))), this.renderRightSideContent())));
    }
    get elm() { return this; }
    static get style() { return topNavCss; }
}, [257, "wui-top-nav", {
        "userMenu": [16, "user-menu"],
        "statusIndicator": [16, "status-indicator"],
        "menuOpen": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-top-nav", "wui-box", "wui-button", "wui-check-input", "wui-close-button", "wui-divider", "wui-form-field", "wui-icon", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-loader", "wui-menu-pane", "wui-more-menu", "wui-status", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-top-nav":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTopNav$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-more-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTopNav = WuiTopNav$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTopNav, defineCustomElement };
